import "bootstrap/dist/css/bootstrap.min.css";
import { ArcElement, Chart as ChartJS, Legend, Tooltip } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Doughnut } from "react-chartjs-2";
import { FaDotCircle } from "react-icons/fa";

// Register chart components
ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

// Accepts props.tireCostByType
const TireCostByPosition = ({ tireCostByType = [] }) => {
  const colors = ["#DC2626", "#22C55E", "#F59E0B", "#9333EA", "#EF4444"];

  const labels = tireCostByType.map((item) => item.tyre_side);
  const values = tireCostByType.map((item) => Number(item.count));

  const data = {
    labels,
    datasets: [
      {
        data: values,
        backgroundColor: colors.slice(0, tireCostByType.length),
        borderWidth: 0,
        cutout: "60%",
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      datalabels: {
        color: "#000",
        formatter: (value, context) => {
          const total = context.dataset.data.reduce((a, b) => a + b, 0);
          const percentage = ((value / total) * 100).toFixed(2);
          return `${percentage}%`;
        },
        font: {
          weight: "bold",
          size: 14,
        },
      },
    },
  };

  return (
    <div
      className="card_container"

    >
      <h5 className="mb-4 scheduled_unscheduled_heading">
        <FaDotCircle color='#3343ea85' />
        Tire Cost by Position
      </h5>
      <hr />
      <div style={{ height: "300px" }}>
        <Doughnut data={data} options={options} plugins={[ChartDataLabels]} />
      </div>
      <div className="d-flex justify-content-around mt-4 flex-wrap text-center">
        {labels.map((label, idx) => (
          <div
            key={label}
            className="fw-semibold"
            style={{ color: colors[idx % colors.length] }}
          >
            ● {label}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TireCostByPosition;
